import { render, staticRenderFns } from "./committee-list.vue?vue&type=template&id=a5bacfaa&scoped=true"
import script from "./committee-list.vue?vue&type=script&lang=js"
export * from "./committee-list.vue?vue&type=script&lang=js"
import style0 from "./committee-list.vue?vue&type=style&index=0&id=a5bacfaa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bacfaa",
  null
  
)

export default component.exports